import { assert, log } from '../app/logger.js';
import { AutocompleteControl } from '../controls/autocomplete_control.js';
import { locations } from '../data/locations.js';
import { recentLocs } from '../location/recent_locs.js';
import { raceWithEvents } from '../util/event_racer.js';
import { listenToEvent } from '../util/listen_to_event.js';

/**
 * Location search autocomplete control.
 */
class LocSearchControl extends AutocompleteControl {
  constructor() {
    super();
    listenToEvent(this, 'itemselect', ev => recentLocs.add(ev.detail));
  }

  initialize() {
    super.initialize();

    if (!this.placeholder) {
      this.placeholder = 'Search Maps';
    }

    // Autoselect text if user didn't started to interact with it.
    this.inputElement.addEventListener('focus', ev =>
      raceWithEvents({
        action() {
          log(`[control:locsearch] eventracer: select text on focus`);
          ev.target.select();
        },
        actionPromise: new Promise(r => setTimeout(r, 100)),
        element: ev.target,
        events: ['keydown', 'mousedown', 'blur'],
      })
    );
  }

  get searchOptions() {
    return {};
  }

  /**
   * Requests items from DB.
   */
  async requestItems(value) {
    log(`[control:locsearch] requestItems for '${value}'`);
    let list = await this.#getItems(value);
    for (let loc of list) {
      loc.img = loc.typeInfo.icon_url;
    }
    return list;
  }

  async #getItems(value) {
    if (!value) {
      return recentLocs.search(this.searchOptions);
    }

    assert(this.map, `[control:locsearch] no map is set`);
    let { north, east, south, west } =
      this.bounds || (await this.map.retrieveBounds());

    let options = Object.assign(
      {
        name: value,
        north,
        east,
        south,
        west,
      },
      this.searchOptions
    );
    return locations.search(options);
  }
}

export { LocSearchControl };
